export default "__VITE_ASSET__iJ0vy6x7__"